import { Typography } from "@mui/material";
import { Stack } from "@mui/system";

import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import { useState } from "react";
import BrandsSortBy from "./BrandsSortBy";

const options = [
  "Unibet",
  "Betting Brand",
  "8 BET",
  "Bet Star",
  "Betting Brother",
];

const BrandsSearchFilter = () => {
  const [value, setValue] = useState<string | null>(options[4]);
  return (
    <>
      <Typography variant="body1" sx={{ mt: 1,fontWeight:typography.Font_weight.Medium.$value }}>
        Performance
      </Typography>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={1}
        mb={2}
      >
        <Autocomplete
          options={options}
          value={value}
          popupIcon={null}
          onChange={(_, newValue) => setValue(newValue)}
          sx={{
            width: '85%',
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.md.$value,
            },
            "& .MuiOutlinedInput-root": {
              paddingRight: spacing.Spacing.none.$value + "!important",
              height: spacing.Spacing["6xl"].$value,
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
              "& .MuiAutocomplete-paper": {
                border: `1px solid ${colors.GrayLightMode[300].$value}`,
                borderRadius: spacing.Radius.md.$value,
                boxShadow: "none", // optional
              },
            },
          }}
          size="medium"
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: spacing.Spacing["5xl"].$value,
                position: "relative",
                backgroundColor: selected ? colors.Brand[50].$value : "",
              }}
            >
              {selected && (
                <CheckIcon
                  fontSize="small"
                  sx={{
                    position: "absolute",
                    left: spacing.Spacing.lg.$value,
                  }}
                />
              )}
              <span>{option}</span>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color="secondary"
              placeholder="Search for specific brand..."
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {!value && (
                      <SearchOutlinedIcon
                        sx={{
                          color: colors.GrayLightMode[400].$value,
                          cursor: "pointer",
                          mr: spacing.Spacing.sm.$value,
                        }}
                      />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        <BrandsSortBy />
        
      </Stack>
    </>
  );
};

export default BrandsSearchFilter;
